import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "app/store";
import { AppPlatform } from "app/types";

export const useStoreReview = () => {
  const parent = useSelector((state: RootState) => state.user.parent);

  useEffect(() => {
    // Amazon Appstore にはアプリ内レビューの仕組みが無いので送らない
    if (window.kidsAppPlatform === AppPlatform.Amazon) return;

    if ("ReactNativeWebView" in window && parent?.login_count > 10) {
      setTimeout(async () => {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            command: "storeReview",
            data: { period: 30 },
          }),
        );
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parent?.uid]);
};
